import { createEmptyActor } from "xstate";
const emptyActor = createEmptyActor();
let actor = emptyActor;
const listeners = /* @__PURE__ */ new Set();
function isEmptyActor(actor2) {
  return actor2 === emptyActor;
}
function setActor(nextActor) {
  actor = nextActor;
  for (const onActorChange of listeners)
    onActorChange();
}
export {
  actor,
  emptyActor,
  isEmptyActor,
  listeners,
  setActor
};
//# sourceMappingURL=context.js.map
